import React, { useState } from 'react';
import { Grid, Button, TextField } from '@mui/material';
import { eventsService } from '../../../../core/services/eventsService';
import styles from '../SchedulerSetting.module.scss';

interface CreateEventTypeProps {
	backButtonClick: () => void;
	onEventTypeCreated?: () => void;
}

const CreateEventType: React.FC<CreateEventTypeProps> = ({
	backButtonClick,
	onEventTypeCreated,
}) => {
	const [type, setType] = useState({ label: '' });
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError(null);

		if (!type.label.trim()) {
			setError('Event type is required');
			return;
		}

		setIsSubmitting(true);

		try {
			await eventsService.addEventType({ 
				label: type.label,
				active: true, // Always pass true
			});

			onEventTypeCreated?.();

			// Navigate back after a short delay
			setTimeout(() => {
				backButtonClick();
			}, 1500);
		} catch (err: any) {
			setError(err?.message || 'Failed to create event type');
			setIsSubmitting(false);
		}
	};

	return (
		<div className={styles.createTimeOffReason}>
			<Grid container direction="column" spacing={2} pl={2}>
				<Grid container direction="row" justifyContent="space-between">
					<Button className={styles.backButton} onClick={backButtonClick}>
						Back
					</Button>
					<Button
						className={styles.submitButton}
						onClick={handleSubmit}
						disabled={isSubmitting || !type.label.trim()}
					>
						{isSubmitting ? 'Saving...' : 'Save'}
					</Button>
				</Grid>
				<Grid>
					<h1 className={styles.formTitle}>Create New Event Type</h1>
				</Grid>
			</Grid>

			<form className={styles.formContainer} onSubmit={handleSubmit}>
				<TextField
					label="Event Type"
					name="label"
					placeholder="Enter event type"
					value={type.label}
					onChange={(e) => {
						setType({ ...type, label: e.target.value });
						if (error) {
							setError(null);
						}
					}}
					className={styles.input}
					margin="normal"
					fullWidth
					inputProps={{ maxLength: 200 }}
					error={!!error}
					helperText={error || ''}
				/>
			</form>
		</div>
	);
};

export default CreateEventType;

